import React from 'react';
import headerActions from '../../../actions/header';
import LanguageBtn from './btnlanguage';
import LogoutBtn from './btnlogout';

export default class TopLinks extends React.Component {
  static propTypes = {
    links:      React.PropTypes.object,
    topLinks:   React.PropTypes.array,
    language:   React.PropTypes.object,
    loggedUser: React.PropTypes.object
  };

  logout = () => {
    headerActions.logout(this.props.links.logout);
  };

  renderLinks = () => {
    const keys = Object.keys(this.props.topLinks);

    return keys.map(function (key, idx) {
      // because prototype.js messes everything up!!!
      // FIXME, please remove prototype.js
      if (!this.props.topLinks.hasOwnProperty(key)) {
        return false;
      }

      const link = this.props.topLinks[key];
      return (
        <li key={'toplink_' + idx} className="toplinks__secondary__item" data-component="topLinkItem">
          <a href={link.url} className="toplinks__link" aria-label={link.name}>{link.name}</a>
        </li>
      );
    }, this);
  };

  renderLanguageButton = () => {
    if (this.props.language.languages.length > 1) {
      return <LanguageBtn {...this.props} />;
    }
  };

  renderLogoutLink = () => {
    if (this.props.loggedUser) {
      return <LogoutBtn {...this.props} />;
    }
  };

  render () {
    return (
      <div className="toplinks">
        <div className="toplinks--hasprimary__inner">
          {this.renderLanguageButton()}
          <ul className="toplinks__secondary">
            {this.renderLinks()}
          </ul>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/header/toplinks/index.js